<template>
  <div class="main ljb-base-padding flex">
    <img
      :src="stateInfo.src"
      class="imgs">
    <div class="textInfo flex1">
      <p class="ljb-title title">{{ stateInfo.title }}</p>
      <p class="ljb-text text">{{ stateInfo.text }}</p>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  name: 'OrderState',
  props: {
    status: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      // stateInfo: {}
    }
  },
  computed: {
    ...mapGetters('User', [
      'getUserCenter'
    ]),
    stateInfo () {
      return this.getInfo(this.status)
    }
  },
  mounted () {
    this.getInfo(this.status)
  },
  methods: {
    getInfo (status) {
      let payState = {
        src: 'https://cdn.51ljb.cn/ljb-pa_check.png',
        title: '咨询已完成',
        text: '您的咨询已完成，请立即支付'
      }
      let evalState = {
        src: 'https://cdn.51ljb.cn/ljb-pa_check.png',
        title: '支付已完成',
        text: '您的订单已完成支付，期待您的五星好评～'
      }
      if (this.getUserCenter.isMember === this.$dataResource.isMember) {
        evalState.title = '订单已完成'
        evalState.text = '您的订单已完成，期待您的五星好评～'
      }
      let CompState = {
        src: 'https://cdn.51ljb.cn/ljb-pa_check.png',
        title: '订单已完成',
        text: '欢迎再次使用'
      }

      switch (status) {
        case '3': return payState
        case '4': return evalState
        case '5': return CompState
      }
      return {}
    }
  }
}
</script>

<style lang="scss" scoped>
  .imgs{
    width: 40px;
    height: 40px;
    margin-right: 10px;
  }
  .title{
    line-height: 20px;
  }
  .text{
    margin-top: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/orderState.vue